/*
*
* File JS per il template Archive Events
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroFullSlider from 'components/hero-full-slider/hero-full-slider';
import blockGuests from 'components/block-guests/block-guests';
import blockMagazine from 'components/block-magazine/block-magazine';
import cardMagazine from 'components/card-magazine/card-magazine';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-event.scss';

//--------------------------------------------------------------------//

// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

let sceneDays = [];

const manageViewSwitch = () => {
    const switchBtns = document.querySelectorAll('.view-switch__item');
    const wrapProgramInner = document.querySelector('.block-program__inner');
    const menuDefault = document.querySelector('.block-program__container');
    const menuRows = document.querySelector('.block-program__menu-rows');
    const menuTabs = document.querySelector('.block-program__menu-tabs');

    if (!switchBtns.length && !wrapProgramInner) return;
    
    switchBtns.forEach((el) => {
        el.addEventListener('click', (evt) => {
            let currentNav = null;

            switch (evt.currentTarget.dataset.view) {
                case 'tabs':
                    document.querySelector('.view-switch__item.active').classList.remove('active');
                    menuRows.classList.remove('active');
                    menuDefault.classList.remove('active');
                    evt.currentTarget.classList.add('active');
                    wrapProgramInner.classList.remove('view-grid');
                    wrapProgramInner.classList.remove('view-rows');
                    wrapProgramInner.classList.add('view-tabs');
                    menuTabs.classList.add('active');

                    currentNav = menuTabs.querySelector('.block-program__menu-tabs-item.current');

                    if (currentNav)
                    {
                        menuTabs.querySelector('.block-program__menu-tabs-item.current').classList.remove('current');
                        menuTabs.querySelector('.block-program__menu-tabs-item:first-child').classList.add('current');
                    }
                    break;
                case 'rows':
                    document.querySelector('.view-switch__item.active').classList.remove('active');
                    evt.currentTarget.classList.add('active');
                    wrapProgramInner.classList.remove('view-tabs');
                    wrapProgramInner.classList.remove('view-grid');
                    wrapProgramInner.classList.add('view-rows');
                    menuRows.classList.add('active');
                    if (menuTabs) {
                        menuTabs.classList.remove('active');
                    }

                    currentNav = menuTabs.querySelector('.block-program__menu-rows-item.current');

                    if (currentNav)
                    {
                        menuRows.querySelector('.block-program__menu-rows-item.current').classList.remove('current');
                        menuRows.querySelector('.block-program__menu-rows-item:first-child').classList.add('current');
                    }
                    break;
                case 'grid':
                    document.querySelector('.view-switch__item.active').classList.remove('active');
                    if (menuTabs) {
                        menuTabs.classList.remove('active');
                    }
                    menuRows.classList.remove('active');
                    evt.currentTarget.classList.add('active');
                    wrapProgramInner.classList.remove('view-tabs');
                    wrapProgramInner.classList.remove('view-rows');
                    wrapProgramInner.classList.add('view-grid');
                    break;
            }
        })
    });
}
manageViewSwitch();

const manageSceneDays = () => {
    let allDays = document.querySelectorAll('.block-program__day');

    if (!allDays.length) return;
    
    let controller = new ScrollMagic.Controller();

    allDays.forEach((el, index) => {
        let sceneHeight = el.offsetHeight;

        window.addEventListener('resize', () => {
            sceneHeight = el.offsetHeight;

            sceneDays[index].update();
        });

        sceneDays[index] = new ScrollMagic.Scene({
            triggerElement: el,
            offset: 0,
            triggerHook: 0.4,
            duration: sceneHeight
        })
        // .addIndicators()
        .on('enter', function(){
            manageMenuActive(el.id);
        })
        .addTo(controller);
    });
}
manageSceneDays();

const manageMenuActive = (id) => {
    let allMenuItems = document.querySelectorAll('.block-program__menu-rows-item');
    let allMenuItemsTabs = document.querySelectorAll('.block-program__menu-tabs-item');
    let selectMenuItems = document.querySelector('.block-program__menu-rows-select');

    allMenuItems.forEach((el) => {
        el.classList.remove('current');
    });

    document.querySelector(`.block-program__menu-rows-item[data-day="${id}"]`).classList.add('current');
    selectMenuItems.value = id;

    allMenuItemsTabs.forEach((el) => {
        el.classList.remove('current');
    });

    document.querySelector(`.block-program__menu-tabs-item[data-day="${id}"]`).classList.add('current');
    selectMenuItems.value = id;
}

const manageSelectMenu = () => {
    let selectMenuItems = document.querySelector('.block-program__menu-rows-select');

    if (!selectMenuItems) return;

    selectMenuItems.addEventListener('change', (evt) => {
        $('html, body').animate({scrollTop: $(`#${evt.target.value}`).offset().top - 65}, 'slow');
    });
}
manageSelectMenu();

const manageFilters = () => {
    let btnSearch = document.querySelector('.program-filters__cta > a');
    let allSelect = document.querySelectorAll('.program-filters__field select');
    let selectY = document.querySelector('.program-filters__field.search-year');
    let textField = document.querySelector('.program-filters__field.search-text input');

    if (!btnSearch) return;

    // Filter for year
    // if (selectY) {
    //     selectY.addEventListener('change', (evt) => {
    //         let year = evt.target.value;
    //         let base_url = immediaData.path_page_filters;
    //         window.location.href = base_url + "?yr=" + year;
    //     });
    // }

    btnSearch.addEventListener('click', (evt) => {
        evt.preventDefault();
        let selectFilters = [];
        let textQuery = textField.value ? textField.value : false;

        allSelect.forEach((el) => {
            if (el.value.length == 0) return;
            selectFilters[el.id.replace('select-', '')] = el.value;
        });

        //managePushState(selectFilters, textQuery);
        //filterBySelect(selectFilters);
        //filterByText(textQuery);
        checkResultsByDay();

        reloadPage(selectFilters, textQuery);
    });
}
manageFilters();

const reloadPage = (allSelect, text) => {
    let base_url = immediaData.path_page_filters;

    let urlSeo = '';
    let queryArray = [];

    for (let key in allSelect)
    {
        switch (key) {
            case 'theme':
                queryArray.push('th='+allSelect[key]);
                break;
            case 'location':
                queryArray.push('pl='+allSelect[key]);
                break;
            case 'guest':
                queryArray.push('gu='+allSelect[key]);
                break;
            case 'year':
                queryArray.push('yr='+allSelect[key]);
                break;
        }
    }

    if (text.length)
    {
        queryArray.push('t='+text);
    }

    queryArray.forEach((el, i) => {
        if (i == 0)
        {
            urlSeo += '?';
        }
        else
        {
            urlSeo += '&';
        }

        urlSeo += el;
    });

    window.location.href = base_url + urlSeo;
}

const filterBySelect = (selectFilters) => {
    let allEvents = document.querySelectorAll('.block-program__day-item');

    if (!allEvents.length) return;

    allEvents.forEach((el) => {
        let elTheme = el.dataset.theme.split(',');
        let elPlace = el.dataset.place.split(',');
        let elGuest = el.dataset.guest.split(',');

        let hasTheme = true;
        let hasPlace = true;
        let hasGuest = true;
        
        // CHECK IF FILTER VALUE IS IN EVENT DATA ATTR
        if (selectFilters['theme']) {
            hasTheme = elTheme.indexOf(selectFilters['theme']) >= 0 ? true : false;
        }
        if (selectFilters['location']) {
            hasPlace = elPlace.indexOf(selectFilters['location']) >= 0 ? true : false;
        }
        if (selectFilters['guest']) {
            hasGuest = elGuest.indexOf(selectFilters['guest']) >= 0 ? true : false;
        }


        // SHOW / HIDE event
        if (hasTheme && hasPlace && hasGuest)
        {
            el.style.display = 'block';
        }
        else
        {
            el.style.display = 'none';
        }
    });
}

const filterByText = (searchQuery) => {

    if (!searchQuery) return;

    let allEvents = document.querySelectorAll('.block-program__day-item');

    allEvents.forEach((el) => {
        if (el.style.display == 'block')
        {
            let eventTextContent = el.textContent.toLowerCase();

            if(eventTextContent.includes(searchQuery.toLowerCase())) {
                el.style.display = 'block';
            } else {
                el.style.display = 'none';
            }
        }
    });
}

const checkResultsByDay = () => {
    let allDaysList = document.querySelectorAll('.block-program__day-list');

    if (!allDaysList.length) return;

    allDaysList.forEach((day) => {
        let allThisDayEvents = day.querySelectorAll('.block-program__day-item');
        let thisDayHasEvent = [];

        allThisDayEvents.forEach((event, index) => {
            if (event.style.display == 'block')
            {
                thisDayHasEvent[index] = event;
            }
        });

        if (!thisDayHasEvent.length)
        {
            day.querySelector('.block-program__day-not-events').style.display = 'block';
        } 
        else
        {
            day.querySelector('.block-program__day-not-events').style.display = 'none';
        }
    });
}

const managePushState = (allSelect, text) => {
    let base_url = immediaData.path_page_filters;
    let urlSeo = '';
    let queryArray = [];

    for (let key in allSelect)
    {
        switch (key) {
            case 'theme':
                queryArray.push('th='+allSelect[key]);
                break;
            case 'location':
                queryArray.push('pl='+allSelect[key]);
                break;
            case 'guest':
                queryArray.push('gu='+allSelect[key]);
                break;
            case 'year':
                queryArray.push('yr='+allSelect[key]);
                break;
        }
    }

    if (text.length)
    {
        queryArray.push('t='+text);
    }

    queryArray.forEach((el, i) => {
        if (i == 0)
        {
            urlSeo += '?';
        }
        else 
        {
            urlSeo += '&';
        }

        urlSeo += el;
    });

    history.replaceState('', "Page Title", base_url + urlSeo);
}

const checkUrlIsFiltered = () => {
    if (window.location.href.includes('?'))
    {
        document.querySelector('.program-filters__cta > a').click();
    }
}
//checkUrlIsFiltered();

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

heroFullSlider();
blockGuests();
blockMagazine();

//--------------------------------------------------------------------//